__turbopack_context__.v({
  "default": "menu-item-module-scss-module__vD8LRq__default",
  "dense": "menu-item-module-scss-module__vD8LRq__dense",
  "description": "menu-item-module-scss-module__vD8LRq__description",
  "disabled": "menu-item-module-scss-module__vD8LRq__disabled",
  "end": "menu-item-module-scss-module__vD8LRq__end",
  "end-icon": "menu-item-module-scss-module__vD8LRq__end-icon",
  "menu-item": "menu-item-module-scss-module__vD8LRq__menu-item",
  "middle": "menu-item-module-scss-module__vD8LRq__middle",
  "selected": "menu-item-module-scss-module__vD8LRq__selected",
  "start": "menu-item-module-scss-module__vD8LRq__start",
  "start-icon": "menu-item-module-scss-module__vD8LRq__start-icon",
  "title": "menu-item-module-scss-module__vD8LRq__title",
});
